export default __webpack_public_path__ + "28da229339f7b337e6a054ea391018c9.png";